import { SxProps, Theme } from '@mui/material'

export const sectionBox: SxProps<Theme> = {
  border: '1px solid #e0e0e0',
  borderRadius: 2,
  p: 2,
  display: 'flex',
  flexDirection: 'column',
  gap: 1.5
}

export const uploadZone = (hasFile: boolean): SxProps<Theme> => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 1,
  border: '2px dashed',
  borderColor: hasFile ? 'success.main' : 'grey.400',
  borderRadius: 2,
  p: 3,
  cursor: 'pointer',
  backgroundColor: hasFile ? 'success.50' : 'grey.50',
  transition: 'all 0.2s',
  '&:hover': {
    borderColor: 'primary.main',
    backgroundColor: 'primary.50'
  }
})

export const downloadLink: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 0.5,
  cursor: 'pointer',
  color: 'primary.main',
  '&:hover': { opacity: 0.7 }
}
